<button
  #dropdownButton
  class="dropdown__button dropdown__button--{{ color }}"
  [ngClass]="{ 'dropdown__button--active': active, 'dropdown__button--selected': value, 'dropdown__button--disabled': disabled, 'dropdown__button--small': small, 'dropdown__button--mobile-small': mobileSmall }"
  type="button"
  [disabled]="disabled"
  (click)="click()"
>
  <span class="dropdown__button-main">
    <span class="dropdown__button-text">
      <span class="dropdown__button-label">
        @if (color !== 'light') {
          <app-icon [icon]="'search'" [width]="16"></app-icon>
        }
        {{ label }}
      </span>
      @if (value) {
        <span class="dropdown__button-value">{{ value }}</span>
      }
    </span>
  </span>
  <app-icon class="dropdown__button-chevron" [icon]="'chevron-bold'" [height]="16"></app-icon>
</button>
